import { memo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { useTheme } from 'foundations-theming/utils';
import HubSpotVideoPlayer from 'ui-addon-video-player/components/HubSpotVideoPlayer';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { HERO_MEDIA_HEIGHT_DESKTOP, HERO_MEDIA_HEIGHT_MOBILE } from '../constants/dimensions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StableVideoPlayer = /*#__PURE__*/memo(({
  videoId,
  onVideoInteraction
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(HubSpotVideoPlayer, {
    autoPlay: false,
    color: theme.color['fill-accent-neutral-default'],
    mutedByDefault: true,
    objectFit: "cover",
    onEnded: () => onVideoInteraction === null || onVideoInteraction === void 0 ? void 0 : onVideoInteraction(false),
    onPause: () => onVideoInteraction === null || onVideoInteraction === void 0 ? void 0 : onVideoInteraction(false),
    onPlay: () => onVideoInteraction === null || onVideoInteraction === void 0 ? void 0 : onVideoInteraction(true),
    videoId: videoId
  });
});
export function VideoOverlay({
  isVisible,
  onVideoInteraction,
  videoId
}) {
  const {
    isMobile
  } = useResponsiveProps({
    isMobile: {
      xs: true,
      md: false
    }
  });
  const containerProps = {
    position: 'absolute',
    insetBlockStart: '0',
    insetInlineStart: '0',
    insetInlineEnd: '0',
    insetBlockEnd: '0',
    display: isVisible ? 'block' : 'none',
    pointerEvents: 'none'
  };
  if (isMobile) {
    return /*#__PURE__*/_jsx(View, Object.assign({}, containerProps, {
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "start",
        flexDirection: "row",
        insetBlockEnd: "600",
        insetInlineEnd: "0",
        insetInlineStart: "0",
        paddingBlock: "800",
        paddingBlockStart: "1000",
        position: "absolute",
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          blockSize: HERO_MEDIA_HEIGHT_MOBILE,
          borderRadius: "400",
          flexBasis: "100%",
          justifyContent: "center",
          overflow: "hidden",
          paddingBlockEnd: "1000",
          children: /*#__PURE__*/_jsx(StableVideoPlayer, {
            onVideoInteraction: onVideoInteraction,
            videoId: videoId
          })
        })
      })
    }));
  }
  return /*#__PURE__*/_jsx(View, Object.assign({}, containerProps, {
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      paddingBlockStart: "1100",
      paddingInlineStart: "800",
      children: [/*#__PURE__*/_jsx(View, {
        flexBasis: "50%"
      }), /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        blockSize: HERO_MEDIA_HEIGHT_DESKTOP,
        borderRadius: "400",
        flexBasis: "50%",
        justifyContent: "center",
        overflow: "hidden",
        children: /*#__PURE__*/_jsx(StableVideoPlayer, {
          onVideoInteraction: onVideoInteraction,
          videoId: videoId
        })
      })]
    })
  }));
}